import { useDatasetContext } from '@vivli/features/datasets/infrastructure/context';
import { CSSProperties, useEffect } from 'react';
import { DownloadOnlyDataPackageFeature } from '@vivli/shared/features/data-package/feature';
import { Styles } from '@vivli/shared/theme';
import { FieldHeaderComponent, StudyExternalLinksComponent } from '@vivli/shared/components';
import { useTranslation } from 'react-i18next';
import { TranslationKeyEnum } from '@vivli/shared/infrastructure/enum';
import { usePubliclyAvailableFiles } from '@vivli/features/studies/infrastructure/context';
import { useErrorHandling } from '@vivli/shared/infrastructure/hook';
import { first } from 'rxjs/operators';
import { DataPackageStatusEnum } from '@vivli/features/studies/infrastructure/enum';
import { useDataPackageApiContext } from '@vivli/core/infrastructure/context';

const containerStyle: CSSProperties = {
    display: 'grid',
    gridTemplateRows: 'auto auto',
    height: '100%'
};

export const DatasetAttachedDocumentsComponent = () => {
    const { study, user } = useDatasetContext();
    const { t } = useTranslation();
    const studyString = t(TranslationKeyEnum.study);
    const { publiclyAvailableFiles, setDataPackage } = usePubliclyAvailableFiles();
    const dataPackageService = useDataPackageApiContext();
    const { handleError } = useErrorHandling();

    useEffect(() => {
        if (!study || !user) {
            return;
        }

        //get the data package publicly available files for the study
        dataPackageService
            .getStudyDocumentsDataPackage(study.metaDataDataPackageId, study.ipdDataPackageId)
            .pipe(first())
            .subscribe({
                next: (dp) => {
                    if (dp.status === DataPackageStatusEnum.Submitted) {
                        setDataPackage(dp);
                    }
                },
                error: (error) => {
                    handleError('Cannot get the Secondary Data Package', error);
                }
            });
    }, [study, user]);

    return (
        <div style={containerStyle}>
            {user && (
                <>
                    <DownloadOnlyDataPackageFeature
                        dataPackageId={study.metaDataDataPackageId}
                        secondaryDataPackageId={study.ipdDataPackageId}
                        datasetMetaDataDoi={study.studyMetadataDoi}
                        studyOrgId={study.orgId}
                        secondaryFilesToShow={publiclyAvailableFiles}
                    />
                    {<StudyExternalLinksComponent externalLinks={study.externalLinks} documentId={study.id} />}
                </>
            )}
            {!user && (
                <FieldHeaderComponent
                    style={Styles.FORM_ROW}
                    title={`Please log in to view and download any available ${studyString} documents. Use the Sign up dialog first if you do not yet have a login.`}
                />
            )}
        </div>
    );
};
